<template>
  <div class="home-container">
    <el-card shadow="hover">
      <template slot="header">
        <div class="card-header">
          <span>管理后台首页</span>
        </div>
      </template>
      <div class="welcome-content">
        <h3>欢迎使用管理后台</h3>
        <p>这里是管理后台的首页，您可以通过左侧菜单访问各个功能模块。</p>
        <el-divider></el-divider>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-card class="info-card" shadow="hover">
              <div class="info-content">
                <div class="info-title">用户管理</div>
                <div class="info-desc">管理系统用户</div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="info-card" shadow="hover">
              <div class="info-content">
                <div class="info-title">内容管理</div>
                <div class="info-desc">管理心情记录和广场内容</div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="info-card" shadow="hover">
              <div class="info-content">
                <div class="info-title">系统管理</div>
                <div class="info-desc">管理管理员和权限</div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="info-card" shadow="hover">
              <div class="info-content">
                <div class="info-title">数据统计</div>
                <div class="info-desc">查看系统数据统计</div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style scoped>
.home-container {
  width: 100%;
}

.card-header {
  font-size: 16px;
  font-weight: bold;
}

.welcome-content {
  padding: 20px 0;
}

.welcome-content h3 {
  margin-bottom: 10px;
  color: #303133;
}

.welcome-content p {
  margin-bottom: 20px;
  color: #606266;
}

.info-card {
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-content {
  text-align: center;
}

.info-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #303133;
}

.info-desc {
  font-size: 14px;
  color: #606266;
}
</style>